<!-- 创新100+ -->
<template>
    <div class="invate">
        <!-- <div class="invate-btn" @click="handleshowCX">创新100+</div> -->
        <div class="invate-box">
            <div class="invate-bg"></div>
            <div class="invate-content">
                <div class="invate-header">
                    <div class="invate-title"></div>
                    <div class="invate-right">
                        <div class="invate-tab">
                            <div class="invate-tab-item " :class="{ active: tab == 1 }" @click="choseTab(1)">央企</div>
                            <div class="invate-tab-item" :class="{ active: tab == 2 }" @click="choseTab(2)">地方</div>
                        </div>
                        <div class="invate-close" @click="handleCloseCX"></div>
                    </div>

                </div>
                <div class="invate-body">
                    <div class="invate-yq" v-if="tab == 1">
                        <swiper class="carouse-yq" ref="yqSwper" :options="yqswiperOptions">
                            <swiper-slide class="carouse-yq-item" v-for="(item, index) in qy_data" :key="index">
                                <div class="yq-item" v-for="childItem in item" :key="childItem.id">
                                    <div class="cp-pic">
                                        <img :src="`/images/yq/${childItem.tp_url}.jpg`" class="cp-img" alt="">
                                    </div>
                                    <div class="cp-content">
                                        <p>产品名称：{{ childItem.cpmc }}</p>
                                        <p>企业名称：{{ childItem.qymc }}</p>
                                        <p class="cp-je">产品简介：{{ childItem.cpje }}</p>
                                    </div>
                                </div>
                            </swiper-slide>
                            <div class="swiper-button-yqprev" slot="button-prev"></div>
                            <div class="swiper-button-yqnext" slot="button-next"></div>

                        </swiper>

                    </div>
                    <div class="invate-df" v-if="tab == 2">
                        <div class="area-box">
                            <span class="area-name" :class="{ active: nowIndex == index }" @click="choseArea(index)"
                                v-for="(item, index) in df_data" :key="index">{{ item.sf }}</span>
                        </div>
                        <div class="area-carouse-box">
                            <swiper class="swiper" ref="mydfSwiper" :options="swiperOptions">
                                <swiper-slide class="carouse-df-item slide-item" :style="{left: `${virtualData.offset}px`}" v-for="(item,index) in virtualData.slides" :key="item.id">
                                    <div class="df-title">{{ item.sf }}</div>
                                    <div class="df-content-box">
                                        <div class="sf-item" v-for="childItem in item.children" :key="childItem.id">
                                            <div class="cp-pic">
                                                <img :src="`/images/df/${childItem.tp_url}.jpg`" class="df-img" alt="">
                                            </div>
                                            <div class="cp-content">
                                                <p>产品名称：{{ childItem.cpmc }}</p>
                                                <p>企业名称：{{ childItem.qymc }}</p>
                                                <p class="cp-je">产品简介：{{ childItem.cpje }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </swiper-slide>
                                <div class="swiper-button-dfprev" slot="button-prev"></div>
                                <div class="swiper-button-dfnext" slot="button-next"></div>

                            </swiper>

                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import SwiperClass from 'swiper'
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { cx_yq, cx_df } from "@/utils/innvateData"
export default {
    name: "innvate",
    components: {
        Swiper,
        SwiperSlide,
    },
    computed: {
        dfswiper() {
            return this.$refs.mydfSwiper.$swiper;
        },
        yqSwper() {
            return this.$refs.yqSwiper.$swiper;
        }

    },
    data() {
        return {
            tab: 1,
            qy_data: [],
            df_data: [],
            nowIndex: 0,
            showCX: false,
            virtualData: {
                slides: []
            },
            swiperOptions: {
                navigation: {
                    nextEl: ".swiper-button-dfnext",
                    prevEl: ".swiper-button-dfprev",
                },
             
                virtual: {
                    addSlidesBefore: 0,
                    addSlidesAfter: 0,
                    renderExternal: (data) => {
                        console.log("renderExternal", data);
                        this.virtualData = data;
                    },
                    slides: (function () {
                      
                        return cx_df;
                    })(),

                },

                // followFinger: false,
                on: {
                    slideChange: (swiper) => {

                        this.nowIndex = this.dfswiper.activeIndex
                    },
                },
            },
            yqswiperOptions: {
                lazy: true,
                navigation: {
                    nextEl: ".swiper-button-yqnext",
                    prevEl: ".swiper-button-yqprev",
                },
            },
        }
    },
    methods: {
        choseTab(num) {
            this.tab = num
        },
        choseArea(num) {

            this.dfswiper.slideTo(num, 500, false);
        },
        handleshowCX() {
            this.showCX = true;
            window.goldlog.record("/spec.1.1", "", "snsScene=创新100+&product=phoneweb&pagename=云上2023年中国品牌博览会", "")
        },
        handleCloseCX() {
            this.tab = 1;
            this.nowIndex = 0;
            this.$emit("close")

        }
    },

    created() {
        for (var i = 0, len = cx_yq.length; i < len; i += 2) {
            this.qy_data.push(cx_yq.slice(i, i + 2));
        }
        this.df_data = cx_df;

    },
}
</script>
<style lang="scss" scoped>
@mixin background-com {
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.invate {
    .invate-btn {
        width: 182px;
        height: 62px;
        line-height: 55px;
        cursor: pointer;
        text-align: center;
        color: #ffffff;
        font-size: 20px;
        position: absolute;
        right: 84px;
        bottom: 60px;
        background-image: url("../../assets/img/btn-bg.png");
        @include background-com();
    }

    .invate-box {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;

        .invate-bg {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-color: rgba($color: #000000, $alpha: 0.7);
        }

        .invate-content {
            width: 10.00rem;
            height: 16rem;
            background-image: url("../../assets/img/chuangxin/bg.png");
            @include background-com();
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);


            .invate-header {
                width: 100%;
                height: 1.85rem;
                padding-left: 0.4rem;
                padding-right: 0.2rem;
                display: flex;

                justify-content: space-between;
                align-items: center;
            }

            .invate-title {
                width: 2.24rem;
                height: 0.5rem;
                background-image: url("../../assets/img/chuangxin/title.png");
                @include background-com();
            }

            .invate-right {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .invate-close {
                width: 0.8rem;
                height: 0.8rem;
                background-image: url("../../assets/img/chuangxin/close.png");
                @include background-com();
                cursor: pointer;
            }

            .invate-tab {
                display: flex;
                margin-right: 0.3rem;
                margin-top: 0.1rem;

                .invate-tab-item {
                    font-size: 0.32rem;
                    width: 1.6rem;
                    height: 1rem;
                    line-height: 0.8rem;
                    text-align: center;
                    color: #ffffff;
                    font-weight: bold;
                    cursor: pointer;
                    margin-left: 0.2rem;

                    &.active {
                        @include background-com();
                        background-image: url("../../assets/img/chuangxin/tab-active.png");
                    }
                }
            }

            .invate-body {
                width: 100%;
                height: calc(100% - 1.85rem);

                .swiper-button-dfprev,
                .swiper-button-yqprev,
                .swiper-button-dfnext,
                .swiper-button-yqnext {
                    width: 0.68rem;
                    height: 0.68rem;
                    position: absolute;
                    @include background-com();
                    top: 50%;
                    margin-top: -0.34rem;
                    cursor: pointer;
                    z-index: 10;

                    &::after {
                        display: none;
                    }

                    &.swiper-button-disabled {
                        opacity: 0.35;
                        cursor: auto;
                    }
                }

                .swiper-button-dfprev,
                .swiper-button-yqprev {
                    left: 0;
                    background-image: url("../../assets/img/chuangxin/arrow-left.png");
                }

                .swiper-button-dfnext,

                .swiper-button-yqnext {
                    right: 0;
                    background-image: url("../../assets/img/chuangxin/arrow-right.png");
                }

                .invate-yq {
                    width: 100%;
                    height: 100%;
                    padding: 0.4rem;


                }

                .carouse-yq {
                    height: 100%;

                }

                .carouse-yq-item {
                    display: flex;
                    overflow-y: auto;
                    overflow-x: hidden;
                    flex-wrap: wrap;
                    scrollbar-width: none;
                    /* firefox */
                    -ms-overflow-style: none;

                    /* IE 10+ */
                    &::-webkit-scrollbar {
                        display: none;
                        /* Chrome Safari */
                    }
                }

                .yq-item {
                    width: 100%;
                    padding-bottom: 0.4rem;
                    position: relative;
                    height: 8.5rem;
                    padding-left: 0.2rem;
                    margin-bottom: 0.3rem;

                    &::after {
                        content: "";
                        display: block;
                        position: absolute;
                        bottom: 0;
                        width: 100%;
                        height: 3px;
                        left: 50%;
                        transform: translate(-50%, 0);
                        /*background-image: url("../../assets/img/chuangxin/border.png");*/
                        @include background-com();
                    }

                    &:nth-child(3) {
                        &::after {
                            display: none;
                        }
                    }



                    .cp-pic {
                        width: 8rem;
                        height: 5rem;
                        margin: 0 auto;
                        margin-bottom: 0.1rem;
                        flex-shrink: 0;
                        overflow: hidden;
                        background-color: #ffffff;

                        img {
                            height: 100%;
                            width: 100%;
                            object-fit: cover;
                        }
                    }

                    .cp-content {
                        height: 3.4rem;
                        width: 8rem;
                        color: #d72e10;
                        font-size: 0.4rem;
                        text-align: left;
                        padding-left: 0.5rem;
                        overflow-y: auto;
                        overflow-x: hidden;

                        scrollbar-width: none;
                        /* firefox */
                        -ms-overflow-style: none;

                        /* IE 10+ */
                        &::-webkit-scrollbar {
                            display: none;
                            /* Chrome Safari */
                        }

                        p {
                            margin-bottom: 0.1rem;
                            line-height: 1.5;
                        }
                    }
                }

                .invate-df {
                    width: 100%;
                    height: 100%;
                    padding: 0.2rem;
                    display: flex;
                    flex-direction: column;
                }

                .area-box {
                    width: 8.2rem;
                    height: 3rem;
                    text-align: center;
                    word-wrap: break-word;
                    margin: 0 auto;
                    margin-bottom: 0.2rem;

                    .area-name {
                        color: #891500;
                        font-size: 0.25rem;
                        padding: 0 5px;
                        line-height: 0.55rem;
                        border-right: 1px solid #891500;
                        cursor: pointer;

                        &:last-child {
                            border-right: none;
                        }

                        &.active {
                            text-decoration: underline;
                        }

                    }
                }

                .area-carouse-box {
                    width: 100%;
                    height: calc(100% - 2rem);

                }

                .carouse-df-item {

                    height: 100%;
                    width: 100% !important;
                    overflow: hidden;

                    .df-title {
                        width: 100%;
                        height: 0.88rem;
                        background-image: url("../../assets/img/chuangxin/title-bg.png");
                        @include background-com();
                        text-align: center;
                        font-size: 0.42rem;
                        color: #d72e10;
                        line-height: 0.88rem;
                    }

                    .df-content-box {
                        height: calc(100% - 2rem);
                        width: 100%;

                        padding: 0 0.3rem;
                        overflow-y: auto;
                        overflow-x: hidden;

                        scrollbar-width: none;
                        /* firefox */
                        -ms-overflow-style: none;

                        /* IE 10+ */
                        &::-webkit-scrollbar {
                            display: none;
                            /* Chrome Safari */
                        }
                    }

                    .sf-item {
                        height: 9rem;
                        width: 100%;

                        padding: 0.2rem 0.51rem;
                        position: relative;

                        &::after {
                            content: "";
                            display: block;
                            position: absolute;
                            bottom: 0;
                            width: 100%;
                            height: 3px;
                            left: 50%;
                            transform: translate(-50%, 0);
                            /*background-image: url("../../assets/img/chuangxin/border.png");*/
                            @include background-com();
                        }

                        &:last-child {
                            &::after {
                                display: none;
                            }
                        }

                        .cp-pic {
                            width: 8rem;
                            height: 5rem;
                            flex-shrink: 0;
                            overflow: hidden;
                            text-align: center;
                            background-color: #ffffff;

                            img {
                                height: 100%;
                                width: 100%;
                                object-fit: cover;
                            }
                        }

                        .cp-content {
                            height: 3.6rem;
                            width: 8.1rem;
                            color: #d72e10;
                            font-size: 0.4rem;
                            text-align: left;
                            padding-left: 0rem;
                            overflow-y: auto;
                            overflow-x: hidden;

                            scrollbar-width: none;
                            /* firefox */
                            -ms-overflow-style: none;

                            /* IE 10+ */
                            &::-webkit-scrollbar {
                                display: none;
                                /* Chrome Safari */
                            }

                            p {
                                margin-bottom: 0.2rem;
                                line-height: 1.5;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
<style>
.carouse-yq .swiper-wrapper {
    scrollbar-width: none;
    /* firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
}

.carouse-yq .swiper-wrapper::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
}

.area-carouse-box .swiper-container,
.invate-yq .swiper-container {
    height: 100%;
    /* padding: 0 0.8rem; */
}
</style>